

































// Utilities
import { get, sync } from 'vuex-pathify';

export default {
  name: 'LayoutBreadcrumbs',

  data: () => ({
    tab: null
  }),

  computed: {
    currentEvent: get('event/currentEvent'),
    ...(sync('app/*') as any),

    routeName() {
      const name = this.$route.name;
      if (name != null) {
        return name.replace(/-/g, ' ');
      }
      return '';
    }
  }
};
